var $ = require("jquery");

var ItemMarker = function (ctrl, item, gmapMarker, isClosed) {

    var _self = this;
    var googleMap;;
    var infoWindow = new google.maps.InfoWindow({
        maxWidth: 270,
        minWidth: 160
    });
    
    google.maps.event.addListener(gmapMarker, "click", function () {
        if (googleMap) {
            _self.active();
        }
    });
    
    google.maps.event.addListener(infoWindow, 'closeclick', function () {
        _self.inactive();
    });
    
    _self.setWindowHtml = function (html) {
        infoWindow.setContent(html);
    };

    _self.active = function (map) {
        if (map) googleMap = map;
        infoWindow.open(map, gmapMarker);
    };

    _self.visible = function() {
        return gmapMarker.visible;
    }

    _self.hide = function () {
        gmapMarker.setVisible(false);
    }

    _self.show = function () {
        if (!gmapMarker.visible) {
            gmapMarker.setVisible(true);
            gmapMarker.setAnimation(google.maps.Animation.ln);
            setTimeout(function () { gmapMarker.setAnimation(null); }, 750);
        }
    }

    _self.inactive = function () {
        infoWindow.close();
    };

    // Icône "pin" pour les dossiers en cours
    var iconPin = function () {
        gmapMarker.setIcon({
            url: require("./icons/pin.png"),
            size: new google.maps.Size(40, 36),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 18),
            scaledSize: new google.maps.Size(40, 36)
        });
    };
    // Icône "dot" pour les dossiers terminés depuis 2010 
    var iconDot = function () {
        var size = 12;
        gmapMarker.setIcon({
            url: require("./icons/dot.png"),
            size: new google.maps.Size(size, size),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(size/2, size/2),
            scaledSize: new google.maps.Size(size, size)
        });
    };

    (function () {
        gmapMarker.clickable = true;
        google.maps.event.addListener(gmapMarker, 'click', function () {
            ctrl.openItem(item);
        });

        if (isClosed) {
            iconDot();
        } else {
            iconPin();
        }
    })();

};

module.exports = function (ctrl, itemHtmlElement) {

    var _self = this,
        $item = null,
        lat = 0,
        lng = 0,
        isOpen = false,
        isArchived = true,
        regionCodes = [],
        marker = null;
    
    _self.open = function (map) {
        if (isOpen) return;
        if (marker) {
            marker.setWindowHtml($item.html());
            marker.active(map);
        }
        isOpen = true;
    };

    _self.close = function () {
        if (!isOpen) return;
        if (marker) {
            marker.inactive();
        }
        isOpen = false;
    };

    _self.setGmapMarker = function (gmapMarker) {
        marker = new ItemMarker(ctrl, _self, gmapMarker, isArchived);
    };

    _self.getLat = function () {
        return lat;
    };

    _self.getLng = function () {
        return lng;
    };

    _self.onVisibilityChange = function() {

    }

    _self.isVisible = function() {
        return marker.visible();
    }

    _self.isOpen = function () {
        return isOpen;
    };

    (function () {
        $item = $(itemHtmlElement);
        lat = parseFloat($item.data("lat"));
        lng = parseFloat($item.data("lng"));
        isArchived = $item.attr("data-is-archived") === "1";
        regionCodes = $item.attr("data-region-code").split(",");

        var regionSelect = $("#regionCode");
        regionSelect.change(function () {
            var newValue = $(this).val();
            if (newValue === "-" || regionCodes.includes(newValue)) {
                marker.show();
            } else {
                marker.hide();
            }
            _self.onVisibilityChange();
        });
    })();

};


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-region-map/RegionMapItem.js